import http from '../http-common';

const API_URL_PATH = 'interviews/';
const API_URL_PATH_TYPES = 'interviews-type/';
const API_URL_PATH_TYPES_WITHOUT_BAR = 'interviews-type';
const API_URL_PATH_ANALYSIS_CONFIGS = 'interviews-analysis-config/';
const API_URL_PATH_ANALYSIS_CONFIGS_WITHOUT_BAR = 'interviews-analysis-config/';
const API_URL_PATH_INFO = 'utils/feedbacks/';

class InterviewsDataService {
  findAll() {
    return http.get(API_URL_PATH);
  }

  findOne(id) {
    return http.get(API_URL_PATH + id);
  }

  create(interview) {
    return http.post(API_URL_PATH, interview);
  }

  createNoCVInterview(interview) {
    return http.post(API_URL_PATH + 'no-cv', interview);
  }

  update(id, interview) {
    return http.put(API_URL_PATH + id, interview);
  }

  updateInterviewStatus(id) {
    return http.put(API_URL_PATH + 'update-status/' + id);
  }

  updateInterviewTranscription(id, transcription) {
    return http.put(API_URL_PATH + 'update-transcription/' + id, transcription);
  }

  delete(id, idCandidate, idPosition) {
    return http.delete(API_URL_PATH + id, {
      data: {
        candidateId: idCandidate,
        positionId: idPosition,
      },
    });
  }

  resendMail(interview_id) {
    return http.get(API_URL_PATH + 'resend-email?interviewId=' + interview_id);
  }

  registerCall(idCandidate, idInterview, idInterviewer) {
    return http.get(
      API_URL_PATH +
        'call?candidateId=' +
        idCandidate +
        '&interviewId=' +
        idInterview +
        '&interviewerId=' +
        idInterviewer
    );
  }

  getInterviewInfo(token) {
    return http.get(API_URL_PATH + token);
  }

  findAllInterviewTypes(page, limit) {
    return http.get(API_URL_PATH_TYPES_WITHOUT_BAR + '?page=' + page + '&limit=' + limit);
  }

  findOneInterviewType(id) {
    return http.get(API_URL_PATH_TYPES + id);
  }

  createInterviewType(type) {
    return http.post(API_URL_PATH_TYPES, type);
  }

  updateInterviewType(type) {
    return http.put(API_URL_PATH_TYPES + type.id, type);
  }

  deleteInterviewType(id) {
    return http.delete(API_URL_PATH_TYPES + id);
  }

  findAllInterviewAnalysisTypes(page, limit) {
    return http.get(
      API_URL_PATH_ANALYSIS_CONFIGS_WITHOUT_BAR + '?page=' + page + '&limit=' + limit
    );
  }

  findOneInterviewAnalysisType(id) {
    return http.get(API_URL_PATH_ANALYSIS_CONFIGS + id);
  }

  /** The platform's active configuration (404 `NO_ACTIVE_CONFIG` when none is). */
  findActiveInterviewAnalysisType() {
    return http.get(API_URL_PATH_ANALYSIS_CONFIGS + 'active');
  }

  getInterviewAnalysisTypeDefaults() {
    return http.get(API_URL_PATH_ANALYSIS_CONFIGS + 'defaults/engines');
  }

  getGestureCatalog() {
    return http.get(API_URL_PATH_ANALYSIS_CONFIGS + 'gesture-catalog');
  }

  createInterviewAnalysisType(type) {
    return http.post(API_URL_PATH_ANALYSIS_CONFIGS, type);
  }

  updateInterviewAnalysisType(type) {
    return http.put(API_URL_PATH_ANALYSIS_CONFIGS + type.id, type);
  }

  deleteInterviewAnalysisType(id) {
    return http.delete(API_URL_PATH_ANALYSIS_CONFIGS + id);
  }

  /**
   * Stored versions of an analysis config with ledger usage (X1), newest first:
   * `[{ id, version, gestures_mongo_config_id, created_at, created_by, notes, engines_hash,
   *   status, used_by_runs, edited_in_place }]`.
   * @param {number} id analysis config id
   * @returns {Promise}
   */
  getConfigVersions(id) {
    return http.get(API_URL_PATH_ANALYSIS_CONFIGS + id + '/versions');
  }

  getFeedbackInfo() {
    return http.get(API_URL_PATH_INFO);
  }

  sendFeedback(opinion, comment, candidateId, interviewId) {
    const data = {
      feedback: opinion.toUpperCase(),
      comment: comment,
      candidateId: candidateId,
    };
    return http.post(API_URL_PATH + interviewId + '/feedback/', data);
  }

  acceptTerms(interviewId, userId) {
    const data = {
      userId: userId,
    };
    return http.post(API_URL_PATH + interviewId + '/treatments/', data);
  }
}

export default new InterviewsDataService();
